import CurrencyPairItemETF from './CurrencyPairItemETF';

export default CurrencyPairItemETF;
